export default "__VITE_ASSET__DvNl9QLO__"